import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import PastRoleForm from '../../common/PastRolesQuestion/PastRoleForm';
import { date } from '../../../dateUtils';
import { analyticsTrack } from '../../../analyticsUtils';
var months = [{
  label: 'January',
  value: '0'
}, {
  label: 'February',
  value: '1'
}, {
  label: 'March',
  value: '2'
}, {
  label: 'April',
  value: '3'
}, {
  label: 'May',
  value: '4'
}, {
  label: 'June',
  value: '5'
}, {
  label: 'July',
  value: '6'
}, {
  label: 'August',
  value: '7'
}, {
  label: 'September',
  value: '8'
}, {
  label: 'October',
  value: '9'
}, {
  label: 'November',
  value: '10'
}, {
  label: 'December',
  value: '11'
}];
var editablePastRole = function editablePastRole(pastRole) {
  var pr = {
    title: pastRole.title,
    role: pastRole.role,
    companyName: pastRole.company_name,
    current: pastRole.current,
    is_suggested: pastRole.is_suggested,
    remove: false
  };
  if (pastRole.start_date) {
    var startDateArray = pastRole.start_date.split('-').map(function (x) {
      return Number(x);
    });
    // Subtracted 1 to get the correct month
    var startDate = new Date(startDateArray[0], startDateArray[1] - 1, startDateArray[2]);
    pr.startDateMonth = months[startDate.getMonth()];
    var startYear = startDate.toLocaleString('default', {
      year: 'numeric'
    });
    pr.startDateYear = {
      label: startYear,
      value: startYear
    };
  }
  if (pastRole.end_date) {
    var endDateArray = pastRole.end_date.split('-').map(function (x) {
      return Number(x);
    });
    var endDate = new Date(endDateArray[0], endDateArray[1] - 1, endDateArray[2]);
    pr.endDateMonth = months[endDate.getMonth()];
    var endYear = endDate.toLocaleString('default', {
      year: 'numeric'
    });
    pr.endDateYear = {
      label: endYear,
      value: endYear
    };
  }
  return pr;
};
var submittablePastRole = function submittablePastRole(pastRole) {
  var submittableStartDate = null;
  var submittableEndDate = null;
  if (pastRole.startDateMonth) {
    submittableStartDate = new Date("".concat(pastRole.startDateMonth.label, " 1, ").concat(pastRole.startDateYear.label)).toISOString('default', {
      month: 'numeric',
      year: 'numeric'
    }).slice(0, 10);
  } else if (pastRole.startDateYear) {
    submittableStartDate = new Date("".concat(pastRole.startDateYear.label)).toISOString('default', {
      month: 'numeric',
      year: 'numeric'
    }).slice(0, 10);
  }
  if (pastRole.endDateMonth) {
    submittableEndDate = new Date("".concat(pastRole.endDateMonth.label, " 1, ").concat(pastRole.endDateYear.label)).toISOString('default', {
      month: 'numeric',
      year: 'numeric'
    }).slice(0, 10);
  } else if (pastRole.endDateYear) {
    submittableEndDate = new Date("".concat(pastRole.endDateYear.label)).toISOString('default', {
      month: 'numeric',
      year: 'numeric'
    }).slice(0, 10);
  }
  var pr = {
    title: pastRole.title,
    role: pastRole.role,
    company_name: pastRole.companyName,
    start_date: submittableStartDate,
    end_date: submittableEndDate,
    current: pastRole.current,
    is_suggested: pastRole.is_suggested,
    is_edited: pastRole.is_edited || false,
    remove: pastRole.remove
  };
  return pr;
};
var ClaimPastRole = /*#__PURE__*/function (_Component) {
  function ClaimPastRole(props) {
    var _this;
    _classCallCheck(this, ClaimPastRole);
    _this = _callSuper(this, ClaimPastRole, [props]);
    _this.state = {
      isHovering: false,
      showModal: false,
      pastRole: editablePastRole(props.pastRole),
      errors: []
    };
    _this.handleMouseOver = _this.handleMouseOver.bind(_this);
    _this.handleMouseLeave = _this.handleMouseLeave.bind(_this);
    _this.handleShowModal = _this.handleShowModal.bind(_this);
    _this.handleCloseModal = _this.handleCloseModal.bind(_this);
    _this.handleInputChange = _this.handleInputChange.bind(_this);
    _this.handleDateChange = _this.handleDateChange.bind(_this);
    _this.handleDelete = _this.handleDelete.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    return _this;
  }
  _inherits(ClaimPastRole, _Component);
  return _createClass(ClaimPastRole, [{
    key: "handleMouseOver",
    value: function handleMouseOver() {
      this.setState({
        isHovering: true
      });
    }
  }, {
    key: "handleMouseLeave",
    value: function handleMouseLeave() {
      this.setState({
        isHovering: false
      });
    }
  }, {
    key: "handleShowModal",
    value: function handleShowModal() {
      this.setState({
        isHovering: false,
        showModal: true
      });
      analyticsTrack('Clicked Edit past role', {
        location: 'Onboarding Flow',
        specific_location: 'Claim Info'
      });
    }
  }, {
    key: "handleCloseModal",
    value: function handleCloseModal() {
      this.setState({
        isHovering: false,
        showModal: false
      });
    }
  }, {
    key: "handleInputChange",
    value: function handleInputChange(value, key) {
      var pastRole = this.state.pastRole;
      pastRole[key] = value;
      pastRole.is_edited = true;
      this.setState({
        pastRole: pastRole
      });
    }
  }, {
    key: "handleDateChange",
    value: function handleDateChange(value, key) {
      var pastRole = this.state.pastRole;
      pastRole[key] = value;
      pastRole.is_edited = true;
      this.setState({
        pastRole: pastRole
      });
    }
  }, {
    key: "handleValidation",
    value: function handleValidation() {
      var pastRole = this.state.pastRole;
      var error = [];
      if (!pastRole.title) {
        error.push('title');
      }
      if (!pastRole.companyName) {
        error.push('company name');
      }
      if (pastRole.startDateYear == null) {
        error.push('start date');
      }
      if (!pastRole.current) {
        if (pastRole.endDateYear == null) {
          error.push('end date');
        } else if (!error.includes('start date')) {
          var safeStartMonth = pastRole.startDateMonth ? pastRole.startDateMonth.value : null;
          var safeEndMonth = pastRole.endDateMonth ? pastRole.endDateMonth.value : null;
          var startDate = new Date(pastRole.startDateYear.value, safeStartMonth);
          var endDate = new Date(pastRole.endDateYear.value, safeEndMonth);
          if (startDate > endDate) {
            error = error.concat(['end date', 'The end date must be after the start date.']);
          }
        }
      }
      return error;
    }
  }, {
    key: "handleDelete",
    value: function handleDelete() {
      var pastRole = this.state.pastRole;
      var _this$props = this.props,
        handleUpdatePastRole = _this$props.handleUpdatePastRole,
        index = _this$props.index;
      pastRole.remove = !pastRole.remove;
      handleUpdatePastRole(submittablePastRole(pastRole), index);
      analyticsTrack("Clicked ".concat(pastRole.remove ? 'Delete' : 'Add', " past role"), {
        location: 'Onboarding Flow',
        specific_location: 'Claim Info'
      });
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit() {
      var errors = this.handleValidation();
      if (errors.filter(function (e) {
        return e.length > 0;
      }).length === 0) {
        var pastRole = this.state.pastRole;
        var _this$props2 = this.props,
          handleUpdatePastRole = _this$props2.handleUpdatePastRole,
          index = _this$props2.index;
        handleUpdatePastRole(submittablePastRole(pastRole), index);
        this.setState({
          errors: []
        });
        this.handleCloseModal();
      } else {
        this.setState({
          errors: errors
        });
      }
    }
  }, {
    key: "renderPastRoleForm",
    value: function renderPastRoleForm() {
      var _this2 = this;
      var _this$state = this.state,
        pastRole = _this$state.pastRole,
        errors = _this$state.errors;
      return /*#__PURE__*/React.createElement("form", {
        className: "edit-past-role",
        onSubmit: function onSubmit(event) {
          return event.preventDefault();
        }
      }, /*#__PURE__*/React.createElement(PastRoleForm, {
        classNamePrefix: "profile-add-past-role",
        pastRole: pastRole,
        errors: errors,
        handleInputChange: this.handleInputChange,
        handleDateChange: this.handleDateChange
      }), /*#__PURE__*/React.createElement("div", {
        className: "center"
      }, /*#__PURE__*/React.createElement("button", {
        className: "btn btn-primary",
        onClick: function onClick() {
          return _this2.handleSubmit();
        }
      }, "Save")));
    }
  }, {
    key: "render",
    value: function render() {
      var pastRole = this.props.pastRole;
      var _this$state2 = this.state,
        isHovering = _this$state2.isHovering,
        showModal = _this$state2.showModal;
      return /*#__PURE__*/React.createElement("div", {
        className: "past-role g-row g-row--between",
        onMouseOver: this.handleMouseOver,
        onMouseLeave: this.handleMouseLeave
      }, /*#__PURE__*/React.createElement(Modal, {
        dialogClassName: "past-roles-modal",
        className: "style-guide",
        show: showModal,
        onHide: this.handleCloseModal
      }, /*#__PURE__*/React.createElement(Modal.Header, {
        closeButton: true
      }), /*#__PURE__*/React.createElement(Modal.Body, null, this.renderPastRoleForm())), /*#__PURE__*/React.createElement("div", {
        className: "g-flex-8 ".concat(pastRole.remove && 'remove-past-role')
      }, /*#__PURE__*/React.createElement("div", {
        className: "fs-hide medium-weight"
      }, pastRole.title), /*#__PURE__*/React.createElement("div", {
        className: "fs-hide"
      }, pastRole.role), /*#__PURE__*/React.createElement("div", {
        className: "fs-hide"
      }, pastRole.company_name), /*#__PURE__*/React.createElement("div", {
        className: "mute fs-hide"
      }, date(pastRole.start_date, pastRole.end_date, pastRole.current))), isHovering && /*#__PURE__*/React.createElement("div", {
        className: "g-flex-4"
      }, /*#__PURE__*/React.createElement("button", {
        className: "btn btn-small btn-secondary",
        onClick: this.handleShowModal
      }, "Edit"), /*#__PURE__*/React.createElement("button", {
        className: "btn btn-small btn-warning",
        onClick: this.handleDelete
      }, pastRole.remove ? 'Add' : 'Delete')));
    }
  }]);
}(Component);
ClaimPastRole.propTypes = {
  pastRole: PropTypes.shape({}).isRequired,
  handleUpdatePastRole: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired
};
export default ClaimPastRole;